import { useEffect, useRef } from "react";

/**
 * Reveal: wraps children with scroll-triggered fade-in-up using IntersectionObserver.
 * Lightweight alternative to framer-motion for this case.
 */
export default function Reveal({
  children,
  delay = 0,
  className = "",
  as: Tag = "div",
  testId,
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => el.classList.add("is-visible"), delay);
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.12 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay]);

  return (
    <Tag ref={ref} className={`reveal ${className}`} data-testid={testId}>
      {children}
    </Tag>
  );
}
